module.exports = __webpack_public_path__ + "img/Kitchen.8f94cd74.jpg";